import web3 from './web3';
import bep20Abi from "../Abi/bep20Abi.json";
export default new web3.eth.Contract(bep20Abi, "0xADCFC6bf853a0a8ad7f9Ff4244140D10cf01363C");
